function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Lunacy");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "world-2"
}, React.createElement("path", {
  d: "M0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0C3.6 0 0 3.6 0 8ZM2 8C2 4.7 4.7 2 8 2C11.3 2 14 4.7 14 8C14 11.3 11.3 14 8 14C4.7 14 2 11.3 2 8Z",
  id: "Shape",
  fillRule: "evenodd",
  stroke: "none"
}), React.createElement("path", {
  d: "M0.186044 0.832415C0.486044 0.0324147 1.78604 -0.167585 2.38604 0.132415C2.98604 0.432415 3.48604 0.132415 4.08604 0.832415C4.58604 1.53241 5.08604 1.33241 5.18604 2.33241C5.28604 3.33241 3.88604 5.13242 3.58604 5.63242C3.18604 6.13241 2.18604 5.53242 2.18604 4.13241C2.18604 2.73241 1.48604 2.63242 1.08604 2.53241C0.586044 2.33241 -0.413956 2.23241 0.186044 0.832415Z",
  transform: "translate(4.01416 7.167587)",
  id: "Path",
  stroke: "none"
}), React.createElement("path", {
  d: "M0.05 0.222222C0.05 0.222222 -0.15 0.722222 0.25 0.822222C1.25 1.02222 1.35 1.32222 1.75 1.82222C2.15 2.32222 1.65 2.82222 1.55 3.42222C1.45 3.92222 1.85 4.22222 2.75 4.02222C3.95 3.72222 4.05 5.02222 4.75 4.92222C5.35 4.82222 5.85 5.82222 6.15 5.92222C6.25 5.52222 6.35 5.12222 6.35 4.72222C6.35 2.82222 5.25 1.22222 3.75 0.322222C3.35 0.222222 2.95 0.222222 2.55 0.222222C1.75 0.222222 1.05 -0.277778 0.05 0.222222Z",
  transform: "translate(6.649902 3.277771)",
  id: "Path",
  stroke: "none"
}));

var SvgWorld = function SvgWorld(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    className: "worldIcon",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWorld, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/world.9a993b0c.svg";
export { ForwardRef as ReactComponent };